import star from "../img/star.svg";
import star2 from "../img/star2.svg";

export interface Input {
  size: number;
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
  class?: string;
  variant?: boolean;
  lg?: boolean;
}

<img
  style={
    top: input.top,
    bottom: input.bottom,
    left: input.left,
    right: input.right,
  }
  src=input.variant ? star2 : star
  width=input.size
  height=input.size
  alt=""
  class=["absolute", !input.lg && "hidden-xs", input.class]
>
